import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'ACTIVITY_ADD_CARD_GET',
  GET_SUCCESS: 'ACTIVITY_ADD_CARD_GET_SUCCESS',
  GET_FAILURE: 'ACTIVITY_ADD_CARD_GET_FAILURE',
  POST: 'ACTIVITY_ADD_CARD_POST',
  POST_SUCCESS: 'ACTIVITY_ADD_CARD_POST_SUCCESS',
  POST_FAILURE: 'ACTIVITY_ADD_CARD_POST_FAILURE',
  PATCH: 'ACTIVITY_ADD_CARD_PATCH',
  PATCH_SUCCESS: 'ACTIVITY_ADD_CARD_PATCH_SUCCESS',
  PATCH_FAILURE: 'ACTIVITY_ADD_CARD_PATCH_FAILURE',
};

export const get = actions.get(nodeId => `${BASE_V2_URL}/wb-activities/${nodeId}`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const post = actions.post(() => `${BASE_V2_URL}/wb-activities/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(nodeId => `${BASE_V2_URL}/wb-activities/${nodeId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
